import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import './Tags.css';
import React from 'react';
import { get } from '../../utils';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
export var Tags = function Tags(_ref) {
  var fields = _ref.fields,
    params = _ref.params;
  var targetItems = get(fields, 'data.item.tags.targetItems', []);
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var _React$useState = React.useState([]),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    items = _React$useState2[0],
    setItems = _React$useState2[1];
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  var dotSite = get(sitecoreContext, 'site.name');
  var tagClickAnalytics = fields.data.tagClickAnalytics;
  React.useEffect(function () {
    setItems(targetItems);
    return function () {
      return setItems([]);
    };
  }, [targetItems.length]);
  if (!fields) {
    console.info('Tags component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, " [Tags component is empty: please provide data source]");
    }
    return null;
  }
  var title = get(fields, 'data.settingsItem.title.value');
  var hasItems = Boolean(get(fields, 'data.item.tags.targetItems.length'));
  if (items.length <= 0) {
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("h4", {
        className: "h4 tag-list__heading"
      }, "No tags are specified.");
    } else {
      return /*#__PURE__*/React.createElement("div", null);
    }
  }
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    anchorUrlParameter: params['Anchor Url Parameter']
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-10 offset-md-1"
  }, /*#__PURE__*/React.createElement("div", {
    className: "tag-list",
    "data-cy": "tags"
  }, title && items.length >= 0 && title && /*#__PURE__*/React.createElement("h4", {
    className: "h4 tag-list__heading"
  }, fields.data.settingsItem.title.value), items.length >= 0 && hasItems && /*#__PURE__*/React.createElement("ul", {
    className: "tag-list__ul"
  }, items.map(function (item) {
    var url = get(fields, 'data.settingsItem.listingPage.targetItem.url');
    var value = get(item, 'fullName');
    var fullName = get(item, 'fullName.value');
    var tagUrl = dotSite === 'dotsite' ? url + '?tags=' + fullName : url + '#tag=' + fullName;
    var visible = item.visible ? item.visible.jss.value : undefined;
    return /*#__PURE__*/React.createElement(React.Fragment, null, typeof visible === 'undefined' || visible ? /*#__PURE__*/React.createElement("li", {
      className: "tag-list__li",
      key: value
    }, url && fullName && /*#__PURE__*/React.createElement("a", {
      className: "btn-link tag-list__a",
      href: tagUrl,
      "aria-label": "Tag Item",
      "aria-labelledby": "Tag Item",
      onClick: function onClick() {
        return tealiumClickFunc(tealiumMergeClickData(tagClickAnalytics, params), "# ".concat(item.name));
      }
    }, "#", fullName)) : /*#__PURE__*/React.createElement("span", null));
  }))))));
};
var StyledWrapper = function StyledWrapper(_ref2) {
  var children = _ref2.children,
    rtl = _ref2.rtl,
    anchorUrlParameter = _ref2.anchorUrlParameter;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter,
    className: " ".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles)
  }, children);
};
var commonStyles = "c1xpgs6t";
var ltrStyles = "lmtnhai";
var rtlStyles = "r1t4l4bh";
export default Tags;